import { ConfigurationDeviceResponse } from '@/modules/configurationModule/detail/instrumentation/devices/services/configuration-device/configuration-device.dto'

export enum ConfigurationInstrumentationDevicesTabIndex {
    BASIC = 0,
    VISIBILITY = 1,
    NOTIFICATIONS = 2
}

export interface ConfigurationInstrumentationDevicesModalState {
    device: Partial<ConfigurationDeviceResponse>
    activeTabIndex: number
}
export const initialConfigurationInstrumentationDevicesModalState =
    (): ConfigurationInstrumentationDevicesModalState => ({
        device: {
            active: true
        },
        activeTabIndex: ConfigurationInstrumentationDevicesTabIndex.BASIC
    })
